import type { MouseEventHandler } from 'react';

import type { AutoSubmitRadioButtonProps } from './auto-submit-radio-button.types';

export function AutoSubmitRadioButton({
  onClick,
  ...props
}: AutoSubmitRadioButtonProps) {
  const handleClick: MouseEventHandler<HTMLInputElement> = (event) => {
    const { form } = event.currentTarget;

    onClick?.(event);

    // Wait for the onClick handler to finish before submitting the form
    setTimeout(() => {
      form?.dispatchEvent(
        new Event('submit', {
          cancelable: true,
          bubbles: true,
        }),
      );
    }, 0);
  };

  return (
    <input
      className="absolute opacity-0 tablet:static tablet:inline-block tablet:opacity-100"
      type="radio"
      onClick={handleClick}
      {...props}
    />
  );
}
